import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class VoucherHdrQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  coupon_type?: Optional<string> = Optional.empty();

}

export class VoucherHdrCriteriaModelQuery {
  query = '';

  constructor( VoucherHdrCriteriaModel: VoucherHdrQueryCriteriaClass) {
    if (!VoucherHdrCriteriaModel) {
      return;
    }

    this.query += VoucherHdrCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += VoucherHdrCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += VoucherHdrCriteriaModel.coupon_type.filter(x => x !== '').map(x => '&coupon_type=' + x).orElse('');

    this.query += '&status=' + VoucherHdrCriteriaModel.status;
    this.query += '&orderBy=' + VoucherHdrCriteriaModel.orderBy;
    this.query += '&order=' + VoucherHdrCriteriaModel.order;
    this.query += '&offset=' + VoucherHdrCriteriaModel.offset + '&limit=' + VoucherHdrCriteriaModel.limit;
  }
}
